import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { MdLocalHospital, MdAssignment, MdDelete } from "react-icons/md";

const PrescriptionModal = ({ show, onClose }) => {
  const [selectedType, setSelectedType] = useState("");

  const [tests, setTests] = useState([""]);

  const handleTestChange = (index, value) => {
    const newTests = [...tests];
    newTests[index] = value;
    setTests(newTests);
  };

  const addTestField = () => {
    setTests([...tests, ""]);
  };

  const prestyle = `
    .card-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
 
    .card {
      flex: 1 1 250px;
      max-width: 300px;
      min-height: 150px;
      border: 2px solid #e0e0e0;
      border-radius: 12px;
      padding: 20px;
      text-align: center;
      background-color: #ffffff;
      box-shadow: 0 2px 5px rgba(0,0,0,0.05);
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
 
    .card:hover {
      border-color: #00c853;
      background-color: #e8f5e9;
      box-shadow: 0 4px 12px rgba(0, 200, 83, 0.2);
    }
 
    .card.selected {
      border-color: #00c853;
      background-color: #e8f5e9;
      box-shadow: 0 4px 12px rgba(0, 200, 83, 0.3);
      display: flex;
      align-items: center;
      border-bottom: 24px;
    }
 
    .form-box {
      margin-top: 30px;
      border-top: 1px solid #ddd;
      padding-top: 25px;
    }
 
    .form-box h5 {
      margin-bottom: 20px;
      font-weight: 600;
      color: #333;
    }
 
    .input, .textarea {
      width: 100%;
      padding: 12px;
      margin-bottom: 18px;
      font-size: 15px;
      border: 1px solid #ccc;
      border-radius: 8px;
      outline: none;
      transition: border-color 0.2s;
    }
 
    .input:focus, .textarea:focus {
      border-color: #00c853;
    }
 
    .textarea {
      height: 120px;
      resize: vertical;
    }
 
    .icon {
      font-size: 32px;
      color: #00c853;
      margin-bottom: 12px;
    }
 
    .submit-btn {
       background: #ff6168;
  padding: 1rem;
  font-size: 0.8rem;
  width: fit-content;
  height: 1.5rem;
  border: none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fefefe;
    }


    .row-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.field {
  flex: 1;
  min-width: 250px;
}

.input,
.textarea,
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.textarea {
  height: 100px;
}

  `;

  return (
    <>
      <style>{prestyle}</style>
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        backdrop="static"
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Make Prescription</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="card-group">
            <div
              className={`card ${selectedType === "clinic" ? "selected" : ""}`}
              onClick={() => setSelectedType("clinic")}
            >
              <MdLocalHospital className="icon" />
              <h5>Clinic Prescription</h5>
              <p>Internal tests & progress tracking within the clinic.</p>
            </div>

            <div
              className={`card ${selectedType === "general" ? "selected" : ""}`}
              onClick={() => setSelectedType("general")}
            >
              <MdAssignment className="icon" />
              <h5>General Prescription</h5>
              <p>For minor conditions like flu, fever, and cold.</p>
            </div>
          </div>

          {selectedType === "clinic" && <ClinicPrescriptionForm />}
          {selectedType === "general" && <GeneralPrescriptionForm />}
        </Modal.Body>
      </Modal>
    </>
  );
};

const ClinicPrescriptionForm = () => {
  const [medicines, setMedicines] = useState([
    { name: "", dosage: "", frequency: "", route: "", duration: "", notes: "" },
  ]);
  const [tests, setTests] = useState([{ name: "", priority: "", remarks: "" }]);
  const [assignToClinic, setAssignToClinic] = useState(false);

  const addMedicine = () => setMedicines([...medicines, { name: "" }]);
  const deleteMedicine = (index) => {
    const updated = medicines.filter((_, i) => i !== index);
    setMedicines(updated);
  };

  const addTest = () => setTests([...tests, { name: "" }]);
  const deleteTest = (index) => {
    const updated = tests.filter((_, i) => i !== index);
    setTests(updated);
  };

  return (
    <div className="form-box">
      <h5>Clinic Prescription Form</h5>

      {/* Patient Details */}
      <div style={{ marginBottom: "1.5rem" }}>
        <div className="text-center fw-bold mb-3">Patient Details</div>

        <div className="row-group">
          <div className="field">
            <label className="label">Patient Name</label>
            <input
              type="text"
              className="input"
              placeholder="Enter patient name"
            />
          </div>
          <div className="field">
            <label className="label">Patient ID</label>
            <input
              type="text"
              className="input"
              placeholder="Enter patient ID"
            />
          </div>
          <div className="field">
            <label className="label">Date of Birth</label>
            <input
              type="date"
              className="input"
              placeholder="dd-mmm-yyyy"
            />
          </div>
          <div className="field">
            <label className="label">Gender</label>
            <select className="input">
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
      </div>

      {/* Doctor / Clinic Info */}
      <div className="text-center fw-bold mb-3">Doctor / Clinic Info</div>
      <div className="row-group">
        <div className="field">
          <label className="label">Doctor Name</label>
          <input type="text" className="input" placeholder="Dr. John Doe" />
        </div>
        <div className="field">
          <label className="label">Specialization</label>
          <input
            type="text"
            className="input"
            placeholder="e.g. General Physician"
          />
        </div>
      </div>

      <hr />

      {/* Prescription */}
      <div className="text-center fw-bold mb-3">Prescription</div>
      {medicines.map((med, index) => (
        <div key={index} className="medicine-entry">
          <div className="row-group">
            <div className="field">
              <label className="label">Medicine Name</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. Paracetamol"
              />
            </div>
            <div className="field">
              <label className="label">Dosage</label>
              <input type="text" className="input" placeholder="e.g. 500mg" />
            </div>
            <div className="field">
              <label className="label">Frequency</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. Twice a day"
              />
            </div>
          </div>

          <div className="row-group">
            <div className="field">
              <label className="label">Route</label>
              <input type="text" className="input" placeholder="e.g. Oral" />
            </div>
            <div className="field">
              <label className="label">Duration</label>
              <input type="text" className="input" placeholder="e.g. 5 days" />
            </div>
            <div className="field">
              <label className="label">Notes</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. After meals"
              />
            </div>
          </div>

          <div className="d-flex gap-2 mb-3">
            <Button variant="secondary" size="sm" onClick={addMedicine}>
              + Add Medicine
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => deleteMedicine(index)}
              disabled={medicines.length === 1}
            >
              Delete Medicine
            </Button>
          </div>
          <hr />
        </div>
      ))}

      <hr />

      {/* Test Recommendations */}
      <div className="text-center fw-bold mb-3">Test Recommendations</div>
      {tests.map((test, index) => (
        <div key={index} className="test-entry">
          <div className="row-group">
            <div className="field">
              <label className="label">Test Name</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. Blood Test"
              />
            </div>
            <div className="field">
              <label className="label">Priority</label>
              <select className="input">
                <option value="">Select Priority</option>
                <option value="routine">Routine</option>
                <option value="urgent">Urgent</option>
              </select>
            </div>
            <div className="field">
              <label className="label">Remarks</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. Fasting required"
              />
            </div>
          </div>

          {/* Add/Delete Buttons per Test Entry */}
          <div className="d-flex gap-2 mb-3">
            <Button variant="secondary" size="sm" onClick={addTest}>
              + Add Test
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => deleteTest(index)}
              disabled={tests.length === 1}
            >
              Delete Test
            </Button>
          </div>

          <hr />
        </div>
      ))}

      {/* Final Notes and Submit */}
      <label className="label">Doctor Notes / Instructions</label>
      <textarea
        className="textarea"
        placeholder="Add any specific instructions or follow-up notes"
      />

      <div style={{ marginTop: "1rem" }}>
        <input
          type="checkbox"
          checked={assignToClinic}
          onChange={() => setAssignToClinic(!assignToClinic)}
        />
        <label style={{ marginLeft: "0.5rem" }}>Assign to Clinic</label>
      </div>

      <Button
        variant="success"
        className="submit-btn"
        style={{ marginTop: "1.5rem" }}
      >
        Submit Clinic Prescription
      </Button>
    </div>
  );
};

const GeneralPrescriptionForm = () => (
  <div className="form-box">
    <h5>General Prescription Form</h5>

    <div style={{ marginBottom: "1.5rem" }}>
      <label className="label">Patient Name</label>
      <input type="text" className="input" placeholder="Enter patient name" />

      <label className="label">Age</label>
      <input type="text" className="input" placeholder="Enter patient age" />
    </div>

    <label className="label">Symptoms</label>
    <input
      type="text"
      className="input"
      placeholder="e.g. Fever, Cold, Cough"
    />

    <label className="label">Diagnosis</label>
    <input type="text" className="input" placeholder="e.g. Viral Fever" />

    <label className="label">Medications Prescribed</label>
    <textarea
      className="textarea"
      placeholder="e.g. Paracetamol 500mg, twice a day"
    />

    <label className="label">Advice / Additional Notes</label>
    <textarea
      className="textarea"
      placeholder="Rest for 3 days, drink fluids, etc."
    />
    <Button className="submit-btn">Submit General Prescription</Button>
  </div>
);

export default PrescriptionModal;
